import React, {useContext, useState} from 'react';
import {useSeasonMissionData} from "../../../logs/useTableData";
import IsLoading from "../../../../shared/components/IsLoading";
import ErrorPage from "../../../../shared/components/ErrorPage";
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import { Table, Tag, Tabs, Descriptions } from 'antd';

const SeasonMissionViewer = () => {
    const {playerData} = useContext(PlayerContext);

    const [playerSeasonMission, setPlayerSeasonMission] = useState(Object.values(playerData.playerInfo.subContentData.SeasonMissionData.missionData) || []);
    const [id, setId] = useState(playerData.playerInfo.subContentData.SeasonMissionData.id || 0);
    const [cycleIndex, setCycleIndex] = useState(playerData.playerInfo.subContentData.SeasonMissionData.cycleIndex || 0);
    const [pointInCycle, setPointInCycle] = useState(playerData.playerInfo.subContentData.SeasonMissionData.pointInCycle || 0);
    const [activeTime, setActiveTime] = useState(playerData.playerInfo.subContentData.SeasonMissionData.activeTime || '0000-00-00T00:00:00');

    const {data: seasonMissionData, isLoading: isSeasonMissionLoading, error: seasonMissionError} = useSeasonMissionData();

    const stateText = {
        0: { text: '닫힘', color: 'default' },
        1: { text: '열림', color: 'blue' },
        2: { text: '완료', color: 'green' },
        3: { text: '보상받음', color: 'gold' },
    };

    // 일차별로 그룹화
    const groupedByDay = {};
    playerSeasonMission.forEach((mission) => {
        const missionInfo = seasonMissionData?.find((m) => m.index === mission.id) || {};
        const day = missionInfo.day ?? '-';
        if (!groupedByDay[day]) groupedByDay[day] = [];
        groupedByDay[day].push({
            key: mission.id,
            name: missionInfo.name ?? '-',
            count: mission.count,
            state: mission.state,
        });
    });

    const dayList = Object.keys(groupedByDay).sort((a, b) => Number(a) - Number(b));
    const [activeDay, setActiveDay] = useState('1');

    const columns = [
        {
            title: '미션이름',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        },
        {
            title: 'count',
            dataIndex: 'count',
            key: 'count',
            width: 100,
            render: (count) => <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{count}</span>,
        },
        {
            title: '상태',
            dataIndex: 'state',
            key: 'state',
            width: 120,
            render: (state) => {
                const info = stateText[state] || { text: state, color: 'default' };
                return <Tag color={info.color}>{info.text}</Tag>;
            },
        },
    ];

    const error = seasonMissionError;
    const isLoading = isSeasonMissionLoading;

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    return (
        <div>
            <Descriptions title="이벤트 정보" bordered size="small" style={{ marginBottom: 16 }}>
                <Descriptions.Item label="이벤트ID">{id}</Descriptions.Item>
                <Descriptions.Item label="cycleIndex">{cycleIndex}</Descriptions.Item>
                <Descriptions.Item label="pointInCycle">{pointInCycle}</Descriptions.Item>
                <Descriptions.Item label="activeTime">{activeTime}</Descriptions.Item>
            </Descriptions>
            <Tabs
                activeKey={activeDay}
                onChange={setActiveDay}
                items={dayList.map(day => ({
                    key: day,
                    label: `${day}일차`,
                }))}
                style={{ marginBottom: 16 }}
            />
            <Table
                columns={columns}
                dataSource={groupedByDay[activeDay] || []}
                pagination={false}
                bordered
                size="small"
            />
        </div>
    );
};

export default SeasonMissionViewer;